import type { AllegroResponsiblePerson } from '../../../api/allegro/responsibleperson/responsiblePersonTypes';
import type { ExcelRow } from '../../excel/types';
import { serializeExcel } from '../../excel/serializeExcel';
import { XLSX_MIME_TYPE } from '../../excel/constants';
import { downloadData } from '../../../utils/downloadData';
import COLUMNS from './responsiblePersonExcelSchema';

const SHEET_NAME = 'Responsible persons';
const DEFAULT_FILE_NAME = 'responsible-persons.xlsx';

function mapExcelRow(person: AllegroResponsiblePerson): ExcelRow {
  return {
    [COLUMNS.id]: person.id,
    [COLUMNS.label]: person.name,
    [COLUMNS.name]: person.personalData.name,
    [COLUMNS.countryCode]: person.personalData.address.countryCode,
    [COLUMNS.street]: person.personalData.address.street,
    [COLUMNS.postalCode]: person.personalData.address.postalCode,
    [COLUMNS.city]: person.personalData.address.city,
    [COLUMNS.email]: person.personalData.contact.email ?? undefined,
    [COLUMNS.phoneNumber]: person.personalData.contact.phoneNumber ?? undefined,
    [COLUMNS.formUrl]: person.personalData.contact.formUrl ?? undefined,
  };
}

export default async function downloadResponsiblePersonsExcel(
  persons: AllegroResponsiblePerson[],
  fileName: string = DEFAULT_FILE_NAME,
): Promise<void> {
  const rows = persons.map(mapExcelRow);
  const blob = await serializeExcel(rows, {
    sheetName: SHEET_NAME,
    headers: Object.values(COLUMNS),
  });

  downloadData(blob, XLSX_MIME_TYPE, fileName);
}
